import { Component, Inject, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  standalone: false,
  selector: 'app-performance-dashboard-barchart',
  templateUrl: './performance-dashboard-barchart.component.html',
  styleUrl: './performance-dashboard-barchart.component.scss'
})
export class PerformanceDashboardBarchartComponent implements OnInit {
  closeModal!: () => void
  title: string = ''

  constructor (
    public dialogRef: MatDialogRef<PerformanceDashboardBarchartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit () {}

  onClose (): void {
    if (this.closeModal) {
      this.closeModal()
    } else {
      this.dialogRef.close()
    }
  }
}
